/**
 * Created by Ning Jiang on 4/6/2017.
 */

import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {
    SequentiallyBetWayInitialWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetWayInitialWPController";
import * as gsap from "gsap";
import {Sine, TweenLite} from "gsap";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WixxParsedGameData} from "../server/data/WixxParsedGameData";
import {WixxGameConfig} from "../WixxGameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Wixx} from "../Wixx";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BitmapText} from "pixi.js";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinWaysWonIndicator} from "./winwayswon/WinWaysWonIndicator";
import hex2rgb = PIXI.utils.hex2rgb;

export class IndiSymWinHighlightPresentation extends SequentiallyBetWayInitialWPController {
    private gameData: WixxParsedGameData;
    private idx:number;

    constructor(indexes: [number, number]) {
        super(indexes, {
            name: "IndiSymWinHighlightPresentation",
            hasWinCountUp: false,
            skippable: false
        });
    }

    protected hasWin(): boolean {
        this.idx=0;
        return Wixx.api.gameClientConfiguration.displayIndividualWinsInGame && this.gameData.betWaysData.length > 0;
    }

    protected addSingleBetWinAnimationToTimeline(betWayWinData: IBetWayWinData, timeline: gsap.Timeline, startTime: number): number {
        this.idx++;
        let winWaysCont: PIXI.Container;
        for (let i: number = 0; i < betWayWinData.reelWinPositions.length; i++) {
            for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                if (betWayWinData.reelWinPositions[i][j]) {
                    const symbol = Reels.getSymbol(i, j);
                    if (symbol) {
                        timeline.add(()=> {
                            symbol.changeState({
                                state: WixxGameConfig.instance.SYMBOL_STATES.win,
                            })
                        }, this.idx);
                        if (i === betWayWinData.length - 1 && j === betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true)) {
                            winWaysCont = this.getWinWaysCont(betWayWinData);
                            timeline.add(() => {
                                StageManager.getLayer(WixxGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).addChild(winWaysCont);
                            })
                            timeline.add(TweenLite.fromTo(winWaysCont.position, 1,
                                {x: winWaysCont.position.x, y: winWaysCont.position.y},
                                {x: winWaysCont.position.x, y: winWaysCont.position.y - 30, ease: Sine.easeOut}), this.idx);
                        }
                    }
                }
            }
        }
        timeline.add(() => {
            StageManager.getLayer(WixxGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name).removeChild(winWaysCont);
        })
        return this.idx;
    }

    protected parseFeatureGameData(data: WixxParsedGameData): void {
        this.gameData = data
    }

    protected startWinPresentation(): void {
        super.startWinPresentation();
    }

    protected stopWinPresentation(isAborted: boolean): void {
        super.stopWinPresentation(isAborted);
    }

    private getWinNumberText(betWayWinData: IBetWayWinData): string {
        let str: string = Currency.formatValue(betWayWinData.amount);
        if (betWayWinData.multiplier > 1) {
            str += ` X ${betWayWinData.multiplier}`;
        }
        return str;
    }

    private getWinWaysCont(betWayWinData: IBetWayWinData): PIXI.Container {
        const mainCont: PIXI.Container = new PIXI.Container();
        const winNumber: PIXI.Text = new PIXI.Text(this.getWinNumberText(betWayWinData), {
            fontFamily: "Open Sans",
            fontSize: 45,
            fontWeight: "800",
            fill: "#ffffff"
        });
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);

        const waysNumber: PIXI.Text = new PIXI.Text(betWayWinData.numberOfCombinations + " ", {
            fontFamily : "Open Sans Condensed light",
            fontSize : 55,
            fill : getWinWaysTextColor(),
            align : "center"
        });
        waysNumber.anchor.set(1, 0.5);

        const waysSprite:PIXI.Sprite=new PIXI.Sprite(GameResources.getTextures(getWaysSpriteString())[0]);
        waysSprite.anchor.set(0.5, 0.5);
        waysSprite.position.x=waysNumber.width;

        const winWaysCont:PIXI.Container = new PIXI.Container();
        winWaysCont.addChild(waysNumber,waysSprite);
        winWaysCont.position.set(-20,65);

        mainCont.addChild(winNumber,winWaysCont);
        mainCont.position.set(Helper.getSymbolPositions(betWayWinData.length - 1, betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true))[0],
            Helper.getSymbolPositions(betWayWinData.length - 1, betWayWinData.reelWinPositions[betWayWinData.length - 1].lastIndexOf(true))[1]);
        return mainCont;

        function getWaysSpriteString():string{
            return betWayWinData.numberOfCombinations>1?WinWaysWonIndicator.FEATURE_TEXT_IMAGES.WAYS_WON.RED_BOOSTER:WinWaysWonIndicator.FEATURE_TEXT_IMAGES.WAY_WON.RED_BOOSTER;
        }

        function getWinWaysTextColor():string{
            return WinWaysWonIndicator.FEATURE_COLORS.RED_BOOSTER;
        }
    }
}